import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  SET_NEWPASSWORD,
  NEW_PASSWORD_REQUIRED,
  NEW_PASSWORD_SESSION_ID,
  GET_ALL_FORMS,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}
export const newPasswordSessionId= sessionId => {
  return {
    type: NEW_PASSWORD_SESSION_ID,
    payload: sessionId,
  }
}
export const newPasswordRequired = isSet => {
  return {
    type: NEW_PASSWORD_REQUIRED,
    payload: isSet,
  }
}
export const getAllForms =()  => {
  return {
    type: GET_ALL_FORMS,
  }
}
export const setNewPassword = (user, history)  => {
  return {
    type: SET_NEWPASSWORD,
    payload: { user, history }
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}
